export default function ComparisonSection() {
  const products = [
    {
      name: "Premium",
      label: "Melhor qualidade",
      price: "€45",
      rating: "9.5",
      popular: true,
      image: "https://readdy.ai/api/search-image?query=Premium%20white%20leather%20sneakers%20on%20dark%20slate%20stone%20pedestal%2C%20luxury%20product%20photography%20with%20dramatic%20contrast%20lighting%2C%20high%20detail%20stitching%20and%20texture%2C%20elegant%20minimalist%20presentation%2C%20deep%20shadows%20and%20bright%20highlights%2C%20gallery%20quality%20still%20life&width=600&height=600&seq=hoobuy-compare-v2-premium-b7d2&orientation=squarish"
    },
    {
      name: "Standard",
      label: "Boa relação qualidade-preço",
      price: "€30",
      rating: "9.0",
      popular: true,
      image: "https://readdy.ai/api/search-image?query=White%20canvas%20sneakers%20photographed%20on%20textured%20concrete%20surface%20with%20green%20plant%20in%20background%2C%20natural%20window%20light%2C%20casual%20lifestyle%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20urban%20loft%20setting%2C%20fresh%20and%20approachable%20style&width=600&height=600&seq=hoobuy-compare-v2-standard-e4f9&orientation=squarish"
    },
    {
      name: "Económico",
      label: "Melhor preço",
      price: "€20",
      rating: "8.5",
      popular: false,
      image: "https://readdy.ai/api/search-image?query=Simple%20white%20casual%20sneakers%20on%20wooden%20floor%20with%20sunlight%20stripes%20through%20window%20blinds%2C%20warm%20natural%20lighting%2C%20affordable%20everyday%20style%2C%20clean%20minimalist%20composition%2C%20cozy%20home%20atmosphere&width=600&height=600&seq=hoobuy-compare-v2-budget-m3t5&orientation=squarish"
    },
  ];

  return (
    <section className="relative bg-background-50 py-16 md:py-24 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12 md:mb-16 gap-6">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-50 rounded-full mb-4">
              Comparação
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 font-medium">
              Comparação de Produtos
            </h2>
          </div>
          <p className="text-foreground-600 text-sm max-w-md">
            Compare qualidade, preço e popularidade dos produtos mais procurados na nossa Hoobuy Spreadsheet
          </p>
        </div>

        {/* Comparison Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {products.map((product, idx) => (
            <div
              key={idx}
              className={`group rounded-2xl overflow-hidden transition-all ${
                idx === 0
                  ? "bg-foreground-900 text-white"
                  : "bg-background-100"
              }`}
            >
              {/* Image */}
              <div className="aspect-square overflow-hidden">
                <img
                  src={product.image}
                  alt={`${product.name} - Hoobuy Spreadsheet`}
                  title={`${product.name} Hoobuy`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="p-6 md:p-7">
                <div className="flex items-center justify-between mb-3">
                  <h3 className={`font-heading text-xl font-medium ${idx === 0 ? "text-white" : "text-foreground-900"}`}>
                    {product.name}
                  </h3>
                  {product.popular && (
                    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium ${
                      idx === 0 ? "bg-accent-500/20 text-accent-300" : "bg-accent-100 text-accent-700"
                    }`}>
                      <i className="ri-fire-line text-xs"></i> Hot
                    </span>
                  )}
                </div>

                <p className={`text-sm mb-4 ${idx === 0 ? "text-white/60" : "text-foreground-600"}`}>
                  {product.label}
                </p>

                <div className="flex items-end justify-between">
                  <span className={`text-3xl md:text-4xl font-heading font-semibold ${idx === 0 ? "text-white" : "text-foreground-900"}`}>
                    {product.price}
                  </span>
                  <span className={`text-sm ${idx === 0 ? "text-white/50" : "text-foreground-500"}`}>
                    {product.rating}/10
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Comparison Table */}
        <div className="mt-12 md:mt-16 bg-background-100 rounded-2xl p-6 md:p-8 overflow-x-auto">
          <h3 className="font-heading text-xl text-foreground-900 font-medium mb-6">Tabela Comparativa</h3>
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="border-b border-background-200">
                <th className="pb-4 font-semibold text-foreground-800 pr-6">Produto</th>
                <th className="pb-4 font-semibold text-foreground-800 pr-6">Preço</th>
                <th className="pb-4 font-semibold text-foreground-800 pr-6">Qualidade</th>
                <th className="pb-4 font-semibold text-foreground-800">Popularidade</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/60">
                <td className="py-4 text-foreground-900 font-medium pr-6">Produto Premium</td>
                <td className="py-4 text-foreground-700 pr-6">€45</td>
                <td className="py-4 pr-6">
                  <span className="inline-flex items-center gap-1 text-accent-600">
                    <i className="ri-star-fill text-xs"></i> Premium
                  </span>
                </td>
                <td className="py-4 text-foreground-700">9.5/10</td>
              </tr>
              <tr className="border-b border-background-200/60">
                <td className="py-4 text-foreground-900 font-medium pr-6">Produto Standard</td>
                <td className="py-4 text-foreground-700 pr-6">€30</td>
                <td className="py-4 pr-6">
                  <span className="inline-flex items-center gap-1 text-accent-600">
                    <i className="ri-star-fill text-xs"></i> Alta
                  </span>
                </td>
                <td className="py-4 text-foreground-700">9.0/10</td>
              </tr>
              <tr>
                <td className="py-4 text-foreground-900 font-medium pr-6">Produto Económico</td>
                <td className="py-4 text-foreground-700 pr-6">€20</td>
                <td className="py-4 pr-6">
                  <span className="inline-flex items-center gap-1 text-secondary-600">
                    <i className="ri-star-fill text-xs"></i> Boa
                  </span>
                </td>
                <td className="py-4 text-foreground-700">8.5/10</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}